<template>
    <b-container>
        <b-row class="bg-info location-details">
            <b-col cols="7 pt-2 pb-1 d-flex flex-column">
                <h6>Adresse</h6>
                <strong>{{ address.location }}</strong>
                <span>{{ address.street }}</span>
                <span>{{ address.zip}} {{ address.city}}</span>
                <span>{{ address.country }}</span>
                <span v-if="address.meeting_point">Treffpunkt {{ address.meeting_point }}</span>

            </b-col>
            <b-col cols="5 px-0">
                <a v-if="!address_incomplete" :href="gmaps_link_url" target="_blank" :style="{ backgroundImage: gmaps_static_url }" class="location-details__map"></a>
                <!-- <static-map :google-api-key="apiKey" v-on:get-url="getUrl" :zoom="zoom" :center="center"></static-map> -->
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
// import StaticMap from 'vue-static-map';
export default {
    name: 'location-details',
    components: {
    },
    methods: {
    },
    data() {
        return {
            api_key: process.env.VUE_APP_GMAPS_STATIC_KEY,
            zoom: 14,
            // center: encodeURI(`${this.address.street}, ${this.address.zip} ${this.address.city}`),
        }
    },
    computed: { 
        address_incomplete () {
            return !this.address.street || !this.address.zip || !this.address.city
        },
        gmaps_static_url() {
            if (this.address_incomplete) {
                return false;
            }
            let url = `https://maps.googleapis.com/maps/api/staticmap?zoom=${this.zoom}&size=300x300&format=png&key=${this.api_key}&scale=1&language=de&center=${this.center}&maptype=roadmap&style=element:labels%7Cvisibility:off&style=feature:administrative.land_parcel%7Cvisibility:off&style=feature:administrative.neighborhood%7Cvisibility:off&markers=color:red%7Clabel:%7C${this.center}`;
            return `url(${url})`;
        },
        center() {
            return encodeURI(`${this.address.street}, ${this.address.zip} ${this.address.city}`);
        },
        gmaps_link_url() {
            if (this.address_incomplete) {
                return false;
            }
            return `https://www.google.com/maps/place/${this.center}`
        }
    },
    props: {
        address: {
            type: Object
        }
    },
}
</script>

<style lang="scss">
@import '../scss/variables';
// @import 'bootstrap/scss/bootstrap.scss';
.location-details {
    font-size: 14px;
    margin-bottom: 15px;

    &__map {
        display: block;
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center center;
    }
}
</style>